<template>
  <div id="totalBox">
    <div class="applyBox">
      <p class="applyTitle">应用平台</p>
      <p class="applyTip">落实于实际，从行业属性出发，定制多种不同的解决方案</p>
      <div class="carouselBox">
        <img src="../../assets/plan/tag.png" class="applyTag"/>
        <img src="../../assets/plan/left.png" alt="" class="carouselIcon" @click="backCarousel"/>
        <transition name="fade">
          <div class="carouselContentBox">
            <div class="carouselContent" v-show="carouselIndex==1">
              <p class="contentTitle">商场解决方案</p>
              <div class="content">
                           通过引入浙江电马云车科技有限公司（以下简称“电马云车”）的定制化停车管理系统解决方案，能够帮助解决小区内停车乱等问题，提高小区停车场智慧化管理水平，提升用户停车满意度，为园区打造一个合理规范的停车环境和制度。
              </div>
              <div class="content">
                         针对中大银座产业园的停车现状，我司认为，应从顺应新时代社会发展的实际出发，坚持“技术领衔、整体优化、兼顾各方、共享共赢”的原则，采取智能化设计路径，用足增量，盘活存量，真正做到让车位流动起来智慧起来，切实满足中大
                         银座产业园的现实停车需求。
              </div>
            </div>
            <div class="carouselContent" v-show="carouselIndex==2">
              <p class="contentTitle">医院解决方案</p>
              <div class="content">
                          通过引入大数据，提高车位流转率，可以根据手机App的二级导航系统迅速找到预定车位，提升了车位的流转效率。车辆
                          离开时通过手机实现自主结费、开通小额免密支付或信用结算等多种自动结算，不需在道闸停留缴费找零，大大提高工作
                          效率，每一台车通过出口的时间预计在5秒—8秒，比原有效率高一倍！也不需要其他某些结算系统“扫一扫”的过程，减
                          少人工管理成本，不远的将来可实现无人值守，而无人值守必将是停车场终端管理的趋势。
              </div>
              <div class="content">
                         相较于现有管理模式，车位预定、精准导航、智能车牌识别和结算管理系统在停车场入口管理上可以提升20%以上的管理效
                          率，提升用户体验度。通过引导和计费调整等方式，将停车场内的车辆规范停放，提升停车场形象。
              </div>
            </div>
            <div class="carouselContent" v-show="carouselIndex==3">
              <p class="contentTitle">小区解决方案</p>
              <div class="content">
                           通过引入浙江电马云车科技有限公司（以下简称“电马云车”）的定制化停车管理系统解决方案，能够帮助解决小区内停
                           车乱等问题，提高小区停车场智慧化管理水平，提升用户停车满意度，为园区打造一个合理规范的停车环境和制度。
              </div>
              <div class="content">
                           针对小区的停车现状，我司认为，应从顺应新时代社会发展从实际出发，坚持<span style="color: rgba(35, 24, 21, 1);font-weight: Bold;">“技术领衔、整体优化、兼顾各方、共享共赢”</span>
                          的原则，采取智能化设计路径，用足增量，盘活存量，真正做到让车位流动起来智慧起来，切实满足小区的停车需求。
              </div>
            </div>
          </div>
        </transition>
        <img src="../../assets/plan/right.png" alt="" class="carouselIcon" @click="frontCarousel"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Apply',
  data: function () {
    return {
      msg: '1',
      carouselIndex: 1,
      timeInterval: 0
    }
  },
  created: function () {
    this.setInterval()
  },
  methods: {
    backCarousel: function () {
      clearInterval(this.timeInterval)
      if (this.carouselIndex === 1) {
        this.carouselIndex = 3
      } else {
        this.carouselIndex -= 1
      }
      this.setInterval()
    },
    frontCarousel: function () {
      clearInterval(this.timeInterval)
      if (this.carouselIndex === 3) {
        this.carouselIndex = 1
      } else {
        this.carouselIndex += 1
      }
      this.setInterval()
    },
    setInterval: function () {
      var that = this
      this.timeInterval = setInterval(function () {
        if (that.carouselIndex === 3) {
          that.carouselIndex = 1
        } else {
          that.carouselIndex += 1
        }
      }, 20000)
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 510px;
  background-color: RGBA(248, 248, 248, 1);
}
.applyBox{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding-top: 40px;
}
.applyTitle{
  text-align:center;
  font-size:30px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:36px;
}
.applyTip{
  font-size:20px;
  font-weight:400;
  color:rgba(80,80,80,1);
  line-height:36px;
  margin-top: 19px;
}
.carouselBox{
  width: 1100px;
  height: 340px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 15px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
}
.applyTag{
  position: absolute;
  top: 0;
  left: 70px;
  width: 32px;
  height: 52px;
}
.carouselContentBox{
  width: 850px;
}
.carouselContent{
  width: 100%;
  margin: 0 auto;
}
.contentTitle{
  font-size: 20px;
  font-weight: bold;
  color: rgba(12,137,24,1);
  line-height: 36px;
  margin-bottom: 20px;
  text-align: left;
}
.content{
  font-size:16px;
  font-weight: 400;
  color: rgba(80,80,80,1);
  line-height: 36px;
  text-align: left;
}
.carouselIcon{
  width: 21px;
  height: 35px;
  cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 6s
}
.fade-enter, .fade-leave-to{
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/plan/apply.vue